import React, { useRef } from 'react'
import { FormGroup, Label, Input, Button } from "reactstrap";
import { kecamatanOptions } from "./constants";

const DataDiri = ({
  fotoKK,
  setFotoKK,
  imagePreviewKK, 
  setImagePreviewKK, 
  isPreviewingFotoKK, 
  setIsPreviewingFotoKK,
  formData, 
  handleChange, 
  errors, 
  desaOptions 
}) => {
  const videoRef = useRef(null);

  const startPreview = async () => {
    try {
      setIsPreviewingFotoKK(true);
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "environment" },
      });
      videoRef.current.srcObject = stream;
      await videoRef.current.play();
    } catch (error) {
      console.error("Error accessing camera:", error);
      setIsPreviewingFotoKK(false);
      alert("Tidak dapat mengakses kamera. Pastikan browser memiliki izin kamera.");
    }
  };

  const capturePhoto = async () => {
    try {
      const canvas = document.createElement("canvas");
      canvas.width = videoRef.current.videoWidth;
      canvas.height = videoRef.current.videoHeight;
      canvas.getContext("2d").drawImage(videoRef.current, 0, 0);

      const dataUrl = canvas.toDataURL("image/png");
      const blob = await fetch(dataUrl).then((res) => res.blob());
      setFotoKK(new File([blob], "captured-photo-kk.png", { type: "image/png" }));
      setImagePreviewKK(dataUrl);

      videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
      setIsPreviewingFotoKK(false);
    } catch (error) {
      console.error("Error capturing photo:", error);
      alert("Gagal mengambil foto. Silakan coba lagi.");
    }
  };

  const cancelPreview = () => {
    setImagePreviewKK(null);
    setFotoKK(null);
    if (isPreviewingFotoKK && videoRef.current && videoRef.current.srcObject) {
      videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
    }
    setIsPreviewingFotoKK(false);
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImagePreviewKK(reader.result);
        setFotoKK(file);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      <FormGroup>
        <Label for="namaKepalaKeluarga">1. Nama Kepala Keluarga</Label>
        <Input 
          type="text" 
          name="namaKepalaKeluarga" 
          id="namaKepalaKeluarga" 
          value={formData.namaKepalaKeluarga || ""} 
          onChange={handleChange} 
          className={errors.namaKepalaKeluarga ? "is-invalid" : ""}
        />
        {errors.namaKepalaKeluarga && <div className="invalid-feedback">{errors.namaKepalaKeluarga}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="nomorKK">2. NO Kartu Keluarga</Label>
        <Input 
          type="text" 
          name="nomorKK" 
          id="nomorKK" 
          value={formData.nomorKK || ""} 
          onChange={handleChange} 
          className={errors.nomorKK ? "is-invalid" : ""}
          placeholder="16 digit nomor KK"
        />
        {errors.nomorKK && <div className="invalid-feedback">{errors.nomorKK}</div>}
      </FormGroup>
      
      <FormGroup>
        <Label for="nik">3. NIK</Label>
        <Input 
          type="text" 
          name="nik" 
          id="nik" 
          value={formData.nik || ""} 
          onChange={handleChange} 
          className={errors.nik ? "is-invalid" : ""}
          placeholder="16 digit NIK"
        />
        {errors.nik && <div className="invalid-feedback">{errors.nik}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="fotoKK">Upload Foto KK</Label>
        
        {/* Tampilkan error untuk foto KK */}
        {errors.fotoKK && <div className="text-danger mb-2">{errors.fotoKK}</div>}
        
        <input 
          type="file" 
          name="fotoKK" 
          id="fotoKK" 
          accept="image/*" 
          onChange={handlePhotoChange}
          style={{ display: "none" }}
        />

        {isPreviewingFotoKK ? (
          <div>
            <video ref={videoRef} style={{ width: "100%", height: "auto" }} />
            <div className="d-flex gap-2 mt-2">
              <Button className="btn btn-primary" onClick={capturePhoto}>
                Ambil Foto
              </Button>
              <Button className="btn btn-secondary" onClick={cancelPreview}>
                Batalkan
              </Button>
            </div>
          </div>
        ) : (
          <div className="d-flex gap-2">
            <Button className="btn btn-primary mt-2 flex-fill" onClick={startPreview}>
              Gunakan Kamera
            </Button>
            <Button 
              className="btn btn-secondary mt-2" 
              onClick={() => document.getElementById("fotoKK").click()}
            >
              📁 Pilih dari Galeri
            </Button>
          </div>
        )}

        {imagePreviewKK && !isPreviewingFotoKK && (
          <div className="mt-3">
            <img 
              src={imagePreviewKK} 
              alt="Preview KK" 
              style={{ 
                width: "100%", 
                maxHeight: "300px", 
                objectFit: "contain",
                border: "1px solid #ddd",
                borderRadius: "4px"
              }} 
            />
            <Button className="btn btn-danger mt-2" onClick={cancelPreview}>
              Hapus Foto
            </Button>
          </div>
        )}
      </FormGroup>
      
      <FormGroup>
        <Label for="alamat">4. Alamat</Label>
        <Input 
          type="text" 
          name="alamat" 
          id="alamat" 
          value={formData.alamat || ""} 
          onChange={handleChange} 
          className={errors.alamat ? "is-invalid" : ""}
        />
        {errors.alamat && <div className="invalid-feedback">{errors.alamat}</div>}
      </FormGroup>
      
      <FormGroup>
        <Label for="kecamatan">5. Kecamatan</Label>
        <Input 
          type="select" 
          name="kecamatan" 
          id="kecamatan" 
          value={formData.kecamatan || ""} 
          onChange={handleChange} 
          className={errors.kecamatan ? "is-invalid" : ""}
        >
          <option value="">Pilih Kecamatan</option>
          {Object.keys(kecamatanOptions).map((kec) => (
            <option key={kec} value={kec}>
              {kec}
            </option>
          ))}
        </Input>
        {errors.kecamatan && <div className="invalid-feedback">{errors.kecamatan}</div>}
      </FormGroup>
      
      <FormGroup>
        <Label for="desaKelurahan">6. Desa/Kelurahan</Label>
        <Input 
          type="select" 
          name="desaKelurahan" 
          id="desaKelurahan" 
          value={formData.desaKelurahan || ""} 
          onChange={handleChange} 
          className={errors.desaKelurahan ? "is-invalid" : ""}
        >
          <option value="">Pilih Desa/Kelurahan</option>
          {desaOptions.map((desa) => (
            <option key={desa} value={desa}>
              {desa}
            </option>
          ))}
        </Input>
        {errors.desaKelurahan && <div className="invalid-feedback">{errors.desaKelurahan}</div>}
      </FormGroup>
    </>
  )
}

export default DataDiri;